import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';

import appReducer from './modules/app/reducers';
import authReducer from './modules/auth/reducers';
import userReducer from './modules/users/reducers';
import organizationsReducer from './modules/organizations/reducers';
import customersReducer from './modules/customers/reducers';
import videosReducer from './modules/videos/reducers';
import promotionCodesReducer from './modules/promotion-codes/reducers';
import videoMenusReducer from './modules/video-menus/reducers';
import projectsReducer from './modules/projects/reducers';
import notificationReducer from './modules/notifications/reducers';
import registerReducer from './modules/registration/reducers';
import passwordRecoveryReducer from './modules/password-recovery/reducers';
import userPermissionsReducer from './modules/user-permissions/reducers';
import listsReducer from './modules/lists/reducers';
import scenesReducer from './modules/scenes/reducers';
import studioReducer from './modules/studio/reducers';
import documentsReducer from './modules/documents/reducers';
import articlesReducer from './modules/articles/reducers';
import articleCommentsReducer from './modules/articleComments/reducers';
import scriptEditorReducer from './modules/script-editor/reducers';
import tabsReducer from './modules/tabs/reducers';
import phoneVerificationReducer from './modules/phone-verification/reducers';
import mediaViewer from './modules/media-viewer/reducers';
import productsReducer from './modules/products/reducers';
import billingReducer from './modules/billing/reducers';
import creditsReducer from './modules/credits/reducers';
import ordersReducer from './modules/orders/reducers';
import modalReducer from './modules/modal/reducers';

const rootReducer = (history: History) => combineReducers({
  app: appReducer,
  auth: authReducer,
  user: userReducer,
  organizations: organizationsReducer,
  customers: customersReducer,
  videos: videosReducer,
  promotionCodes: promotionCodesReducer,
  videoMenus: videoMenusReducer,
  projects: projectsReducer,
  products: productsReducer,
  articles: articlesReducer,
  articleComments: articleCommentsReducer,
  documents: documentsReducer,
  notifications: notificationReducer,
  router: connectRouter(history),
  register: registerReducer,
  passwordRecovery: passwordRecoveryReducer,
  userPermissions: userPermissionsReducer,
  lists: listsReducer,
  scenes: scenesReducer,
  studio: studioReducer,
  scriptEditor: scriptEditorReducer,
  tabs: tabsReducer,
  phoneVerification: phoneVerificationReducer,
  mediaViewer: mediaViewer,
  billing: billingReducer,
  credits: creditsReducer,
  orders: ordersReducer,
  modal: modalReducer,
});

export default rootReducer;
